/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Salvora_P2Inputs */

const es_marketplace_seo_galicia_guide_salvora_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Salvora_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las excursiones suelen salir desde ports como O Grove, Cambados o Vilanova de Arousa e incluyen navegación, tiempo en playas vírgenes y, en muchos casos, explicación del entorno natural.`)
};

const gl_marketplace_seo_galicia_guide_salvora_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Salvora_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As excursiones adoitan saír dende portos como O Grove, Cambados ou Vilanova de Arousa e inclúen navegación, tempo en praias vírgenes e, en moitos casos, explicación do entorno natural.`)
};

const en_marketplace_seo_galicia_guide_salvora_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Salvora_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trips often leave from O Grove, Cambados or Vilanova de Arousa and include sailing, time on wild beaches and often a guide to the natural environment.`)
};

/**
* | output |
* | --- |
* | "Trips often leave from O Grove, Cambados or Vilanova de Arousa and include sailing, time on wild beaches and often a guide to the natural environment." |
*
* @param {Marketplace_Seo_Galicia_Guide_Salvora_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_salvora_p2 = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Salvora_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Salvora_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_salvora_p2(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_salvora_p2(inputs)
	return es_marketplace_seo_galicia_guide_salvora_p2(inputs)
});